module.exports = __webpack_public_path__ + "media/images/logo__rangegoatsgc-4bb41efc37a7fc762fac9f6081c20ec5.png";